module.exports = __webpack_public_path__ + "static/media/icon1.bd304da4.svg";